import {FlowConfigVO} from "@/model/FlowConfigVO";
import { tx } from '@/i18n/pack';

const operatorDetailTips = {
  ALLTIME: "包含所有时间",
  ABSOLUTE: "从起始日期的0点到终止日期的24点",
  BEFFOR: "不包含该日期，即历史到该日期0点",
  AFTER: "从该日期0点到当前时间",
  ATLAST: "从过去N小时/天/周到当前时间：N天即N×24小时、N周即N×7×24小时",
  ATLASTBEFFORE: "从过去N小时/天/周以前的历史所有时间",
}
const timeFunctionsTips = {
  ONLINETONOW: "包含所有时间",
  BEFORE: "不包含该日期，即历史到该日期0点",
  AFTER: "从该日期0点到当前时间",
  DYNAMIC: "当前日期的N天前的0点到M天前的24点。示例：若当前为30号，则过去5天前-3天前，即为25号0点到27号24点",
  LASTXDAYS: "当前日期的N天前的0点计算到当前时间",
  ABSOLUTE: "从起始日期的0点到终止日期的24点",
}
const defaultTimezone = '(GMT+08:00) Asia/Shanghai';
const timezones: {olsonName:string , description: string}[] = [
  {
    "olsonName":"(GMT-12:00) Etc/GMT+12",
    "description":"(GMT-12:00) 国际日期变更线西边"
  },
  {
    "olsonName":"(GMT-11:00) Pacific/Pago_Pago",
    "description":"(GMT-11:00) 美属萨摩亚"
  },
  {
    "olsonName":"(GMT-11:00) Pacific/Midway",
    "description":"(GMT-11:00) 中途岛"
  },
  {
    "olsonName":"(GMT-10:00) Pacific/Honolulu",
    "description":"(GMT-10:00) 夏威夷"
  },
  {
    "olsonName":"(GMT-09:00) America/Juneau",
    "description":"(GMT-09:00) 阿拉斯加"
  },
  {
    "olsonName":"(GMT-08:00) America/Los_Angeles",
    "description":"(GMT-08:00) 太平洋时间（美国和加拿大）"
  },
  {
    "olsonName":"(GMT-08:00) America/Tijuana",
    "description":"(GMT-08:00) 蒂华纳"
  },
  {
    "olsonName":"(GMT-07:00) America/Phoenix",
    "description":"(GMT-07:00) 亚利桑那"
  },
  {
    "olsonName":"(GMT-07:00) America/Chihuahua",
    "description":"(GMT-07:00) 奇瓦瓦"
  },
  {
    "olsonName":"(GMT-07:00) America/Mazatlan",
    "description":"(GMT-07:00) 马萨特兰"
  },
  {
    "olsonName":"(GMT-07:00) America/Denver",
    "description":"(GMT-07:00) 山区时间（美国和加拿大）"
  },
  {
    "olsonName":"(GMT-06:00) America/Guatemala",
    "description":"(GMT-06:00) 中美洲"
  },
  {
    "olsonName":"(GMT-06:00) America/Chicago",
    "description":"(GMT-06:00) 中部时间（美国和加拿大）"
  },
  {
    "olsonName":"(GMT-06:00) America/Mexico_City",
    "description":"(GMT-06:00) 瓜达拉哈拉、墨西哥城"
  },
  {
    "olsonName":"(GMT-06:00) America/Monterrey",
    "description":"(GMT-06:00) 蒙特雷"
  },
  {
    "olsonName":"(GMT-06:00) America/Regina",
    "description":"(GMT-06:00) 萨斯喀彻温"
  },
  {
    "olsonName":"(GMT-05:00) America/Bogota",
    "description":"(GMT-05:00) 波哥大"
  },
  {
    "olsonName":"(GMT-05:00) America/New_York",
    "description":"(GMT-05:00) 东部时间（美国和加拿大）"
  },
  {
    "olsonName":"(GMT-05:00) America/Indiana/Indianapolis",
    "description":"(GMT-05:00) 印第安纳（东部）"
  },
  {
    "olsonName":"(GMT-05:00) America/Lima",
    "description":"(GMT-05:00) 利马、基多"
  },
  {
    "olsonName":"(GMT-04:00) America/Halifax",
    "description":"(GMT-04:00) 大西洋时间（加拿大）"
  },
  {
    "olsonName":"(GMT-04:00) America/Caracas",
    "description":"(GMT-04:00) 加拉加斯"
  },
  {
    "olsonName":"(GMT-04:00) America/Guyana",
    "description":"(GMT-04:00) 乔治敦"
  },
  {
    "olsonName":"(GMT-04:00) America/La_Paz",
    "description":"(GMT-04:00) 拉巴斯"
  },
  {
    "olsonName":"(GMT-04:00) America/Puerto_Rico",
    "description":"(GMT-04:00) 波多黎各"
  },
  {
    "olsonName":"(GMT-04:00) America/Santiago",
    "description":"(GMT-04:00) 圣地亚哥"
  },
  {
    "olsonName":"(GMT-03:30) America/St_Johns",
    "description":"(GMT-03:30) 纽芬兰"
  },
  {
    "olsonName":"(GMT-03:00) America/Sao_Paulo",
    "description":"(GMT-03:00) 巴西利亚"
  },
  {
    "olsonName":"(GMT-03:00) America/Argentina/Buenos_Aires",
    "description":"(GMT-03:00) 布宜诺斯艾利斯"
  },
  {
    "olsonName":"(GMT-03:00) America/Godthab",
    "description":"(GMT-03:00) 格陵兰岛"
  },
  {
    "olsonName":"(GMT-03:00) America/Montevideo",
    "description":"(GMT-03:00) 蒙得维的亚"
  },
  {
    "olsonName":"(GMT-02:00) Atlantic/South_Georgia",
    "description":"(GMT-02:00) 大西洋中部"
  },
  {
    "olsonName":"(GMT-01:00) Atlantic/Azores",
    "description":"(GMT-01:00) 亚速尔群岛"
  },
  {
    "olsonName":"(GMT-01:00) Atlantic/Cape_Verde",
    "description":"(GMT-01:00) 佛得角群岛"
  },
  {
    "olsonName":"(GMT+00:00) Europe/London",
    "description":"(GMT+00:00) 爱丁堡、伦敦"
  },
  {
    "olsonName":"(GMT+00:00) Europe/Lisbon",
    "description":"(GMT+00:00) 里斯本"
  },
  {
    "olsonName":"(GMT+00:00) Africa/Monrovia",
    "description":"(GMT+00:00) 蒙罗维亚"
  },
  {
    "olsonName":"(GMT+00:00) Etc/UTC",
    "description":"(GMT+00:00) UTC"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Amsterdam",
    "description":"(GMT+01:00) 阿姆斯特丹"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Belgrade",
    "description":"(GMT+01:00) 贝尔格莱德"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Berlin",
    "description":"(GMT+01:00) 柏林"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Zurich",
    "description":"(GMT+01:00) 伯尔尼、苏黎世"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Bratislava",
    "description":"(GMT+01:00) 布拉迪斯拉发"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Brussels",
    "description":"(GMT+01:00) 布鲁塞尔"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Budapest",
    "description":"(GMT+01:00) 布达佩斯"
  },
  {
    "olsonName":"(GMT+01:00) Africa/Casablanca",
    "description":"(GMT+01:00) 卡萨布兰卡"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Copenhagen",
    "description":"(GMT+01:00) 哥本哈根"
  },
  {
    "olsonName":"(GMT+00:00) Europe/Dublin",
    "description":"(GMT+00:00) 都柏林"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Ljubljana",
    "description":"(GMT+01:00) 卢布尔雅那"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Madrid",
    "description":"(GMT+01:00) 马德里"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Paris",
    "description":"(GMT+01:00) 巴黎"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Prague",
    "description":"(GMT+01:00) 布拉格"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Rome",
    "description":"(GMT+01:00) 罗马"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Sarajevo",
    "description":"(GMT+01:00) 萨拉热窝"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Skopje",
    "description":"(GMT+01:00) 斯科普里"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Stockholm",
    "description":"(GMT+01:00) 斯德哥尔摩"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Vienna",
    "description":"(GMT+01:00) 维也纳"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Warsaw",
    "description":"(GMT+01:00) 华沙"
  },
  {
    "olsonName":"(GMT+01:00) Africa/Algiers",
    "description":"(GMT+01:00) 中非西部"
  },
  {
    "olsonName":"(GMT+01:00) Europe/Zagreb",
    "description":"(GMT+01:00) 萨格勒布"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Athens",
    "description":"(GMT+02:00) 雅典"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Bucharest",
    "description":"(GMT+02:00) 布加勒斯特"
  },
  {
    "olsonName":"(GMT+02:00) Africa/Cairo",
    "description":"(GMT+02:00) 开罗"
  },
  {
    "olsonName":"(GMT+02:00) Africa/Harare",
    "description":"(GMT+02:00) 哈拉雷"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Helsinki",
    "description":"(GMT+02:00) 赫尔辛基"
  },
  {
    "olsonName":"(GMT+02:00) Asia/Jerusalem",
    "description":"(GMT+02:00) 耶路撒冷"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Kaliningrad",
    "description":"(GMT+02:00) 加里宁格勒"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Kiev",
    "description":"(GMT+02:00) 基辅"
  },
  {
    "olsonName":"(GMT+02:00) Africa/Johannesburg",
    "description":"(GMT+02:00) 比勒陀利亚"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Riga",
    "description":"(GMT+02:00) 里加"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Sofia",
    "description":"(GMT+02:00) 索菲亚"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Tallinn",
    "description":"(GMT+02:00) 塔林"
  },
  {
    "olsonName":"(GMT+02:00) Europe/Vilnius",
    "description":"(GMT+02:00) 维尔纽斯"
  },
  {
    "olsonName":"(GMT+03:00) Asia/Baghdad",
    "description":"(GMT+03:00) 巴格达"
  },
  {
    "olsonName":"(GMT+03:00) Europe/Istanbul",
    "description":"(GMT+03:00) 伊斯坦布尔"
  },
  {
    "olsonName":"(GMT+03:00) Asia/Kuwait",
    "description":"(GMT+03:00) 科威特"
  },
  {
    "olsonName":"(GMT+03:00) Europe/Minsk",
    "description":"(GMT+03:00) 明斯克"
  },
  {
    "olsonName":"(GMT+03:00) Europe/Moscow",
    "description":"(GMT+03:00) 莫斯科、圣彼得堡"
  },
  {
    "olsonName":"(GMT+03:00) Africa/Nairobi",
    "description":"(GMT+03:00) 内罗毕"
  },
  {
    "olsonName":"(GMT+03:00) Asia/Riyadh",
    "description":"(GMT+03:00) 利雅得"
  },
  {
    "olsonName":"(GMT+03:00) Europe/Volgograd",
    "description":"(GMT+03:00) 伏尔加格勒"
  },
  {
    "olsonName":"(GMT+03:30) Asia/Tehran",
    "description":"(GMT+03:30) 德黑兰"
  },
  {
    "olsonName":"(GMT+04:00) Asia/Muscat",
    "description":"(GMT+04:00) 阿布扎比、马斯喀特"
  },
  {
    "olsonName":"(GMT+04:00) Asia/Baku",
    "description":"(GMT+04:00) 巴库"
  },
  {
    "olsonName":"(GMT+04:00) Europe/Samara",
    "description":"(GMT+04:00) 萨马拉"
  },
  {
    "olsonName":"(GMT+04:00) Asia/Tbilisi",
    "description":"(GMT+04:00) 第比利斯"
  },
  {
    "olsonName":"(GMT+04:00) Asia/Yerevan",
    "description":"(GMT+04:00) 埃里温"
  },
  {
    "olsonName":"(GMT+04:30) Asia/Kabul",
    "description":"(GMT+04:30) 喀布尔"
  },
  {
    "olsonName":"(GMT+05:00) Asia/Yekaterinburg",
    "description":"(GMT+05:00) 叶卡捷林堡"
  },
  {
    "olsonName":"(GMT+05:00) Asia/Karachi",
    "description":"(GMT+05:00) 伊斯兰堡、卡拉奇"
  },
  {
    "olsonName":"(GMT+05:00) Asia/Tashkent",
    "description":"(GMT+05:00) 塔什干"
  },
  {
    "olsonName":"(GMT+05:30) Asia/Kolkata",
    "description":"(GMT+05:30) 金奈、加尔各答、孟买、新德里"
  },
  {
    "olsonName":"(GMT+05:30) Asia/Colombo",
    "description":"(GMT+05:30) 斯里哈亚华登尼普拉"
  },
  {
    "olsonName":"(GMT+05:45) Asia/Kathmandu",
    "description":"(GMT+05:45) 加德满都"
  },
  {
    "olsonName":"(GMT+06:00) Asia/Almaty",
    "description":"(GMT+06:00) 阿拉木图"
  },
  {
    "olsonName":"(GMT+06:00) Asia/Dhaka",
    "description":"(GMT+06:00) 阿斯塔纳、达卡"
  },
  {
    "olsonName":"(GMT+06:00) Asia/Urumqi",
    "description":"(GMT+06:00) 乌鲁木齐"
  },
  {
    "olsonName":"(GMT+06:30) Asia/Rangoon",
    "description":"(GMT+06:30) 仰光"
  },
  {
    "olsonName":"(GMT+07:00) Asia/Bangkok",
    "description":"(GMT+07:00) 曼谷、河内"
  },
  {
    "olsonName":"(GMT+07:00) Asia/Jakarta",
    "description":"(GMT+07:00) 雅加达"
  },
  {
    "olsonName":"(GMT+07:00) Asia/Krasnoyarsk",
    "description":"(GMT+07:00) 克拉斯诺亚尔斯克"
  },
  {
    "olsonName":"(GMT+07:00) Asia/Novosibirsk",
    "description":"(GMT+07:00) 新西伯利亚"
  },
  {
    "olsonName":"(GMT+08:00) Asia/Shanghai",
    "description":"(GMT+08:00) 北京"
  },
  {
    "olsonName":"(GMT+08:00) Asia/Chongqing",
    "description":"(GMT+08:00) 重庆"
  },
  {
    "olsonName":"(GMT+08:00) Asia/Hong_Kong",
    "description":"(GMT+08:00) 香港"
  },
  {
    "olsonName":"(GMT+08:00) Asia/Irkutsk",
    "description":"(GMT+08:00) 伊尔库次克"
  },
  {
    "olsonName":"(GMT+08:00) Asia/Kuala_Lumpur",
    "description":"(GMT+08:00) 吉隆坡"
  },
  {
    "olsonName":"(GMT+08:00) Australia/Perth",
    "description":"(GMT+08:00) 珀斯"
  },
  {
    "olsonName":"(GMT+08:00) Asia/Singapore",
    "description":"(GMT+08:00) 新加坡"
  },
  {
    "olsonName":"(GMT+08:00) Asia/Taipei",
    "description":"(GMT+08:00) 台北"
  },
  {
    "olsonName":"(GMT+08:00) Asia/Ulaanbaatar",
    "description":"(GMT+08:00) 乌兰巴托"
  },
  {
    "olsonName":"(GMT+09:00) Asia/Tokyo",
    "description":"(GMT+09:00) 大阪、札幌、东京"
  },
  {
    "olsonName":"(GMT+09:00) Asia/Seoul",
    "description":"(GMT+09:00) 首尔"
  },
  {
    "olsonName":"(GMT+09:00) Asia/Yakutsk",
    "description":"(GMT+09:00) 雅库茨克"
  },
  {
    "olsonName":"(GMT+09:30) Australia/Adelaide",
    "description":"(GMT+09:30) 阿德莱德"
  },
  {
    "olsonName":"(GMT+09:30) Australia/Darwin",
    "description":"(GMT+09:30) 达尔文"
  },
  {
    "olsonName":"(GMT+10:00) Australia/Brisbane",
    "description":"(GMT+10:00) 布里斯班"
  },
  {
    "olsonName":"(GMT+10:00) Australia/Melbourne",
    "description":"(GMT+10:00) 堪培拉、墨尔本"
  },
  {
    "olsonName":"(GMT+10:00) Pacific/Guam",
    "description":"(GMT+10:00) 关岛"
  },
  {
    "olsonName":"(GMT+10:00) Australia/Hobart",
    "description":"(GMT+10:00) 霍巴特"
  },
  {
    "olsonName":"(GMT+10:00) Pacific/Port_Moresby",
    "description":"(GMT+10:00) 莫尔兹比港"
  },
  {
    "olsonName":"(GMT+10:00) Australia/Sydney",
    "description":"(GMT+10:00) 悉尼"
  },
  {
    "olsonName":"(GMT+10:00) Asia/Vladivostok",
    "description":"(GMT+10:00) 符拉迪沃斯托克"
  },
  {
    "olsonName":"(GMT+11:00) Asia/Magadan",
    "description":"(GMT+11:00) 马加丹"
  },
  {
    "olsonName":"(GMT+11:00) Pacific/Noumea",
    "description":"(GMT+11:00) 新喀里多尼亚"
  },
  {
    "olsonName":"(GMT+11:00) Pacific/Guadalcanal",
    "description":"(GMT+11:00) 所罗门群岛"
  },
  {
    "olsonName":"(GMT+11:00) Asia/Srednekolymsk",
    "description":"(GMT+11:00) 中科雷姆斯克"
  },
  {
    "olsonName":"(GMT+12:00) Pacific/Auckland",
    "description":"(GMT+12:00) 奥克兰、惠灵顿"
  },
  {
    "olsonName":"(GMT+12:00) Pacific/Fiji",
    "description":"(GMT+12:00) 斐济"
  },
  {
    "olsonName":"(GMT+12:00) Asia/Kamchatka",
    "description":"(GMT+12:00) 堪察加"
  },
  {
    "olsonName":"(GMT+12:00) Pacific/Majuro",
    "description":"(GMT+12:00) 马绍尔群岛"
  },
  {
    "olsonName":"(GMT+12:45) Pacific/Chatham",
    "description":"(GMT+12:45) 查塔姆群岛"
  },
  {
    "olsonName":"(GMT+13:00) Pacific/Tongatapu",
    "description":"(GMT+13:00) 努库阿洛法"
  },
  {
    "olsonName":"(GMT+13:00) Pacific/Apia",
    "description":"(GMT+13:00) 萨摩亚"
  },
  {
    "olsonName":"(GMT+13:00) Pacific/Fakaofo",
    "description":"(GMT+13:00) 托克劳群岛"
  }
]

export function getConfigTips(config: FlowConfigVO): FlowConfigVO {
  if (config.operatorDetail) {
    for (let key of Object.keys(operatorDetailTips)) {
      // @ts-ignore
      const tips = tx(null, `flow.tips.operator.${key}`, operatorDetailTips[key]);
      config.operatorDetail[key] = {...config.operatorDetail[key], tips}
    }
  }
  if (config.timeFunctions) {
    for (let item of config.timeFunctions) {
      // @ts-ignore
      item.tips = tx(null, `flow.tips.time.${item.en}`, timeFunctionsTips[item.en] || '');
    }
  }
  return config;
}

const tagRegStr = '\{\{([^\\|]*)\\|default:\'([^\'}]*)\'\}\}';
const tagList = [
  {value: 'contact.email', label: '邮箱', i18nKey: 'contact.tag.email'},
  {value: 'contact.last_name', label: '姓', i18nKey: 'contact.tag.lastName'},
  {value: 'contact.first_name', label: '名', i18nKey: 'contact.tag.firstName'},
  {value: 'contact.phone_number', label: '电话', i18nKey: 'contact.tag.phone'},
  {value: 'contact.country', label: '国家', i18nKey: 'contact.tag.country'},
  {value: 'contact.province', label: '省', i18nKey: 'contact.tag.province'},
  {value: 'contact.city', label: '城市', i18nKey: 'contact.tag.city'},
  {value: 'contact.zip_code', label: '邮编', i18nKey: 'contact.tag.zipCode'},
  {value: 'contact.first_active', label: '首次活跃', i18nKey: 'contact.tag.firstActive'},
  {value: 'contact.last_active', label: '最后活跃', i18nKey: 'contact.tag.lastActive'},
  {value: 'contact.subscribe_status', label: '订阅状态', i18nKey: 'contact.tag.subscribeStatus'},
  {value: 'contact.hard_bounce_count', label: '硬退回次数', i18nKey: 'contact.tag.hardBounce'},
  {value: 'contact.soft_bounce_count', label: '软退回次数', i18nKey: 'contact.tag.softBounce'},
  {value: 'contact.tags', label: '用户标签', i18nKey: 'contact.tag.tags'}
]
const phoneTagList = [
  {value: 'contact.email', label: '邮箱', i18nKey: 'contact.tag.email'},
  {value: 'contact.last_name', label: '姓', i18nKey: 'contact.tag.lastName'},
  {value: 'contact.first_name', label: '名', i18nKey: 'contact.tag.firstName'},
  {value: 'contact.phone_number', label: '电话', i18nKey: 'contact.tag.phone'},
  {value: 'contact.country', label: '国家', i18nKey: 'contact.tag.country'},
  {value: 'contact.province', label: '省', i18nKey: 'contact.tag.province'},
  {value: 'contact.city', label: '城市', i18nKey: 'contact.tag.city'},
  {value: 'contact.zip_code', label: '邮编', i18nKey: 'contact.tag.zipCode'},
  {value: 'contact.first_active', label: '首次活跃', i18nKey: 'contact.tag.firstActive'},
  {value: 'contact.last_active', label: '最后活跃', i18nKey: 'contact.tag.lastActive'},
  {value: 'contact.subscribe_status', label: '订阅状态', i18nKey: 'contact.tag.subscribeStatus'},
  {value: 'contact.tags', label: '用户标签', i18nKey: 'contact.tag.tags'}
]

export {
  defaultTimezone,
  timezones,
  tagRegStr,
  tagList,
  phoneTagList
}